import gql from 'graphql-tag';

const AUTO_SUGGEST_YEAR = input => gql`
{
  topLobbyingYear(_approxyear: ${parseInt(input)}) {
    lobbyingYear
    confidence
  }
}
`

export default AUTO_SUGGEST_YEAR
